// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".arc-title[data-v-119d30a0]{font-size:16px;font-weight:bold;margin-bottom:20px}.path-root[data-v-119d30a0]{line-height:40px;border-bottom:1px solid #f5f5f5}[data-v-119d30a0] .commonat-table .el-table__body-wrapper{min-height:450px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
